module.exports = __webpack_public_path__ + "img/settings.d0e62016.svg";